import { render, staticRenderFns } from "./AnomalieProduit.vue?vue&type=template&id=27b3d6ca&scoped=true"
import script from "./AnomalieProduit.vue?vue&type=script&lang=js"
export * from "./AnomalieProduit.vue?vue&type=script&lang=js"
import style0 from "./AnomalieProduit.vue?vue&type=style&index=0&id=27b3d6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3d6ca",
  null
  
)

export default component.exports